export const getAssetImageUrl = (imgPath: string) => {
  return require(`../assets/${imgPath}`);
}

export const SUPPORT_ENV = {
  dev: 'development',
  qa: 'qa',
  prod: 'production'
} as const;

export const getCurrentEnv = (
  hostname = window.location.hostname,
  configuredEnv = process.env.VUE_APP_ENV || ''
) => {
  const override = configuredEnv.trim().toLowerCase();
  if (override === 'dev') return SUPPORT_ENV.dev;
  if (override === 'qa') return SUPPORT_ENV.qa;
  if (override === 'prod') return SUPPORT_ENV.prod;
  if (override) {
    throw new Error(`Invalid app environment "${configuredEnv}". Use dev, qa, or prod.`);
  }

  const hostName = hostname.toLowerCase();
  if (
    hostName === 'localhost' || hostName === '127.0.0.1' ||
    hostName.startsWith('dev-') || hostName.endsWith('.rsstratdev.com') ||
    hostName.endsWith('.ltk.rip') || hostName.endsWith('.rscollaborationsdev.com')
  ) {
    return SUPPORT_ENV.dev;
  }
  if (hostName.startsWith('qa-') || hostName.endsWith('.qashopltk.com') || hostName.endsWith('.cloudfront.net')) {
    return SUPPORT_ENV.qa;
  }
  return SUPPORT_ENV.prod;
};
